import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
// import { Container } from './styles';
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
    border: "1px solid #eeeeee",
    overflow: "hidden",
  },
  highlight: {
    border: "1px solid #ffd5c9",
    boxShadow: "0 14px 34px rgba(237, 78, 42, 0.18)",
    background: "linear-gradient(180deg, #fff7f3 0%, #ffffff 45%)",
  },
  media: {
    maxHeight: 340,
    paddingTop: "52%",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
}));

interface IPostProps {
  title: string;
  date: string;
  children: any;
  image: any;
  highlight?: boolean;
}
const Post = ({ title, date, children, image, highlight }: IPostProps) => {
  const classes = useStyles();
  return (
    <Card className={`${classes.root} ${highlight ? classes.highlight : ""}`}>
      <CardHeader
        avatar={
          <img
            src={require("../../Assets/images/icon.png")}
            alt="Menu Legal"
            style={{ width: 36, height: 36 }}
          />
        }
        title="Menu Legal"
        subheader={date}
      />
      <CardMedia className={classes.media} image={image} title={title} />
      <CardContent>{children}</CardContent>
      {/* <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Method:</Typography>
          <Typography paragraph>
            Heat 1/2 cup of the broth in a pot until simmering, add saffron and
            set aside for 10 minutes.
          </Typography>
          <Typography paragraph>
            Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet
            over medium-high heat. Add chicken, shrimp and chorizo, and cook,
            stirring occasionally until lightly browned, 6 to 8 minutes.
            Transfer shrimp to a large plate and set aside, leaving chicken and
            chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes,
            onion, salt and pepper, and cook, stirring often until thickened and
            fragrant, about 10 minutes. Add saffron broth and remaining 4 1/2
            cups chicken broth; bring to a boil.
          </Typography>
          <Typography paragraph>
            Add rice and stir very gently to distribute. Top with artichokes and
            peppers, and cook without stirring, until most of the liquid is
            absorbed, 15 to 18 minutes. Reduce heat to medium-low, add reserved
            shrimp and mussels, tucking them down into the rice, and cook again
            without stirring, until mussels have opened and rice is just tender,
            5 to 7 minutes more. (Discard any mussels that don’t open.)
          </Typography>
          <Typography>
            Set aside off of the heat to let rest for 10 minutes, and then
            serve.
          </Typography>
        </CardContent>
      </Collapse> */}
    </Card>
  );
};

export default Post;
